var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import Col from "antd/es/col";
import "antd/es/col/style/index.js";
import Row from "antd/es/row";
import "antd/es/row/style/index.js";
import { observer } from 'mobx-react';
let AbfragerMultipleChoiceOptionsLayoutGrid = class AbfragerMultipleChoiceOptionsLayoutGrid extends React.PureComponent {
    get numberOfOptions() {
        return React.Children.count(this.props.children);
    }
    get childs() {
        return React.Children.toArray(this.props.children);
    }
    get numberOfGridRows() {
        if (this.numberOfOptions <= 3)
            return 1;
        if (this.numberOfOptions <= 6)
            return 2;
        return 3;
    }
    get numberOfGridColumns() {
        if (this.numberOfOptions === 1)
            return 1;
        if ([2, 4].includes(this.numberOfOptions))
            return 2;
        return 3;
    }
    render() {
        const rows = [];
        let k = 0;
        for (let i = 0; i < this.numberOfGridRows; i++) {
            const columns = [];
            for (let j = 0; j < this.numberOfGridColumns; j++) {
                if (k <= this.childs.length) {
                    columns.push(React.createElement(Col, { span: 24 / this.numberOfGridColumns, key: 10 * i + j, style: {
                            textAlign: 'center',
                            padding: '0.2em',
                            display: 'flex',
                            alignItems: 'stretch',
                            alignSelf: 'stretch'
                        } }, this.childs[k]));
                }
                k++;
            }
            rows.push(React.createElement(Row, { key: i, type: "flex", style: { alignSelf: 'stretch', flex: `1 1 ${100 / this.numberOfGridRows}%`, marginBottom: 4 }, gutter: 11 }, columns));
        }
        return rows;
    }
};
AbfragerMultipleChoiceOptionsLayoutGrid = __decorate([
    observer
], AbfragerMultipleChoiceOptionsLayoutGrid);
export { AbfragerMultipleChoiceOptionsLayoutGrid };
